import { useEffect } from 'react';
import { useOnboardingStore } from '../store/useOnboardingStore';
import Step1 from '../components/MultistepForm/Step1';
import Step2 from '../components/MultistepForm/Step2';
import Step3 from '../components/MultistepForm/Step3';
import GenresStep from '../components/MultistepForm/GenresStep';
import PhotoUploadStep from '../components/MultistepForm/PhotoUploadStep';
import Step4 from '../components/MultistepForm/Step4';
import Step5 from '../components/MultistepForm/Step5';
import StartBoard from '../components/MultistepForm/StartBoard';

const MultiStepForm = () => {
  const {currentStep,fetchQuestions } = useOnboardingStore();

  useEffect(() => {
    fetchQuestions(); // Fetch questions from the store
    // Fetch genres from the store
  }, [fetchQuestions]);

  // Render step components
  switch (currentStep) {
    case 1:
      return <Step1 />;
    case 2:
      return <StartBoard />;
      case 3:
        return <Step2 />; 
        case 4:
          return <Step3 />;   
          case 5:
            return <Step4 />;     
    case 6:
        return <GenresStep />;  
    case 7:
          return <PhotoUploadStep />;      
    case 8:
      return <Step5 />;
    default:
      return null;
  }
};

export default MultiStepForm;
